/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardAccountFilters {
    getFixupPrototypeFunction() { return SecurityDashboardAccountFilters.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardAccountFilters>): SecurityDashboardAccountFilters {
        let obj = Object.assign(new SecurityDashboardAccountFilters(), model);
        SecurityDashboardAccountFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardAccountFilters>): SecurityDashboardAccountFilters {
        if (!model) return null;
        return SecurityDashboardAccountFilters.newInstance(<SecurityDashboardAccountFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardAccountFilters) {
        if (!obj) return;

        models.SecurityDashboardAccountFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardAccountFilters): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardAccountFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API.
     */
    tenants: Array<string>;

    /**
     * Define the Cloud Providers to include.
     */
    clouds: Array<models.CloudServiceName>;

    /**
     * Specify the Cloud Account IDs.
     */
    cloud_accounts: Array<string>;

}
